export class MoleculePanelServiceObjectMachineComponent {
    public templateUrl = require('./panel-service-object-machine.html?external');
}
